import { type BuildDetailsFieldsParams, field } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildLocationFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const location = opportunity?.location;

  return [
    field('Main Vertical Site', location?.main_vertical_site__c),
    field('Deal Category', location?.ac_deal_category__c),
    field('Deal Sub-Category', location?.ac_deal_sub_category__c),
    field('Destination', location?.destination__c),
    field('Sub - Destination', location?.sub_destination__c),
  ];
}
